import { useState, useRef, useEffect, useContext } from 'react'
import { useMutation } from 'components/graphql'
import { FilterContext } from '../context/FilterContext'

const useMultiEdit = ({ sectionData, section }) => {
	const { multiEditMutation: mutation, multiFilterEditMutation: filterMutation, link: subsection } = sectionData
	const { setFilter, ...filters } = useContext(FilterContext)
	const [isActive, setIsActive] = useState(false)
	const [isAllSelected, setIsAllSelected] = useState(false)
	const [recordIds, setRecordIds] = useState([])
	const [multiEdit] = useMutation(mutation)
	const [multiFilterEdit] = useMutation(filterMutation)
	const baseRecordId = useRef()

	useEffect(() => {
		setIsActive(false)
		setRecordIds([])
	}, [subsection])

	const handleMultiEdit = ({ fields }) => {
		if (sectionData.useMultiEditByFilterMutation && isAllSelected) {
			return multiFilterEdit({
				variables: {
					byFilter: {
						...sectionData?.initialQueryVariables?.filter,
						...filters[section]
					},
					fields
				}
			})
		}

		return multiEdit({
			variables: {
				idArr: recordIds,
				fields
			}
		})
	}

	const handleSetIsActive = (isActiveVal, id) => {
		if(isActiveVal) {
			baseRecordId.current = id
			handleSelectRecord(id)
		} else {
			setRecordIds([])
		}
		setIsActive(isActiveVal)
	}

	const handleSelectRecord = id => {
		const isSelected = isRecordSelected(id)
		if(id === baseRecordId.current && isSelected) {
			return
		}
		setRecordIds(idArr => isSelected ?
			idArr.filter(recordId => recordId !== id) :
			[id, ...idArr]
		)
	}

	const isRecordSelected = id => recordIds.indexOf(id) !== -1


	return {
		isActive,
		setIsActive: handleSetIsActive,
		recordIds,
		setRecordIds,
		handleMultiEdit,
		handleSelectRecord,
		isRecordSelected,
		isAllSelected,
		setIsAllSelected
	}
}

export default useMultiEdit
